export default {
    CustomerList: {
        ChooseCustomer: 'Kies klant',
    },

    Customer: {
        SafesOnline: 'Kluizen online',
        CurrentBalance: 'Huidige inhoud',
        DailySales: 'Dagelijkse verkoop',
        ActiveWarnings: 'Actieve waarschuwingen',
        Of: 'OF',
        In: 'IN',
        Branches: 'SITES'
    },

    Branch: {
        ExportTransactions: "Export Transacties",
        ManageOperators: "Beheer gebruikers",
        ShowOnMap: "Toon op map",
        CurrentBalance: "Huidige inhoud",
        DailySales: 'Dagelijkse verkoop',
        MainCurrency: 'Hoofdvaluta',
        TransactionDays: 'Transactie dagen'
    },

    BranchList: {
        Name: 'Naam',
        Status: 'Status',
        BalanceAmount: 'Inventaris',
        BalanceCurrency: 'Valuta inventaris',
        LastBalance: 'Bijgewerkt',
        Branches: 'Sites',
    },

    BranchListFilter: {
        Branches: 'Sites',
        SearchCriteria: 'Zoek site...',
    },


    Chart: {
        Sales: 'Verkoop',
        Pickup: 'CIT',
        Balance: 'Inhoud',
        Difference: 'Verschil',
        Confirmed: 'Bevestigd',
        SalesBalancesAndPickups: 'Verkoop, Inhoud & CIT',
        NoDataAvailable: 'Geen gegevens beschikbaar',
        SafebagBalance: 'Inhoud keepsafe',
        RecyclableBalance: 'Inhoud recycling volume',
        ManualDepositBalance: 'Inhoud manuele stortingen',
        OverflowBalance: 'Overflow inhoud'
    },

    ChartDenominations: {
        Deposited: 'Afgestort',
        Recyclable: 'Recycleerbaar',
        Denominations: 'Denominaties',
        NoDataAvailable: 'Geen gegevens beschikbaar'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Verwerkte verkoop in',
        UnprocessedSales: 'Niet verwerkte verkoop in',
        SalesOut: 'Verkoop Out',
        SalesPerHour: 'Verkoop per uur'
    },

    CustomerHeader: {
        ShowOnMap: 'Toon op map',
        Branches: 'Sites',
        Branch: 'Site',
        ExportTransactions: 'Transacties',
    },
    
    DeviceStatus: {
        AllOk: 'Alles inorde',
    },
    
    DeviceStatusList: {
        Safes: 'Kluizen',
    },

    ExportForm: {
        ExportTransactions: 'Export Transacties',
        Cancel: 'Annuleer',
        Export: 'Export',
        FromDate: 'Begindatum',
        Time: 'Tijd',
        EndDate: 'Einddatum'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'Wachtwoord vergeten?',
        ForgotText: 'Geef uw e-mail adres in en klik hieronder. U zal een e-mail ontvangen met verdere instructies.',
        LoginLink: 'Terug naar login',
        EmailAddress: 'Mailadres',
        Submit: 'Verstuur e-mail',
        ErrorMessage: 'We konden uw verzoek niet naar de server verzenden.'
    },

    LoginPage: {
        LoginHeader: 'Welkom',
        LoginText: 'Log in met uw e-mail en wachtwoord',
        LoginForgot: 'Wachtwoord vergeten?',
        Username: 'E-MAIL',
        Password: 'WACHTWOORD',
        Login: 'Login'
    },

    ResetPasswordPage: {
        ResetHeader: 'Reset wachtwoord',
        ResetText: 'Geef uw nieuw wachtwoord in.'
    },

    Drawer: {
        Dashboard: 'Overzicht',
        SwitchCustomer: 'Verander klant',
        MyProfile: 'Mijn profiel',
        Logout: 'Log uit'
    },

    OperatorForm: {
        UserId: 'GebruikersID',
        FirstName: 'Voornaam',
        LastName: 'Familienaam',
        Pin: 'Pin',
        Save: 'Bewaar',
        Delete: 'Verwijder',
        Operator: 'Gebruiker'
    },

    OperatorList: {
        AddOperator: 'Voeg gebruiker toe',
        Operators: 'Gebruikers',
        Name: 'Naam'
    },

    Profile: {
        Profile: 'Profiel',
        Name: 'Naam',
        Language: 'Taal',
        Password: 'Wachtwoord',
        ConfirmPassword: 'Bevestig wachtwoord',
        Update: 'Update'
    },

    ResetPasswordForm: {
        NewPassword: 'Nieuw wachtwoord',
        ConfirmPassword: 'Bevestig wachtwoord',
        Submit: 'Bevestig'
    },

    InviteUserForm: {
        InviteHeader: 'Gebruiker uitgenodigd',
        InviteText: 'Vul uw gegevens in en druk op bewaar om in te loggen.',
        Name: 'Naam',
        Language: 'Taal',
        NewPassword: 'Nieuw wachtwoord',
        ConfirmPassword: 'Bevestig wachtwoord',
        Submit: 'Bewaar'
    },

    TransactionList: {
        Type: 'Type',
        Operator: 'Gebruiker',
        When: 'Wanneer',
        Amount: 'Bedrag',
        Currency: 'Valuta',
        Transactions: 'Transacties',
        Device: 'Toestel',
        SalesDay: 'Verkoopdag',
        HoverDeposit: 'Verkoop in',
        HoverSalesIn: 'Verkoop in',
        HoverSalesOut: 'Verkoop out',
        HoverManualDeposit: 'Manuele storting',
        HoverCollection: 'Ophaling',
        HoverCollectionNotes: 'Ophaling biljetten',
        HoverCollectionCoins: 'Ophaling munten',
        HoverCollectionEnvelope: 'Ophaling manuele stortingen',
        HoverCollectionOK: 'Ophaling bevestigd',
        HoverCollectionNotesOK: 'Ophaling biljetten bevestigd',
        HoverCollectionCoinsOK: 'Ophaling munten bevestigd',
        HoverCollectionEnvelopeOK: 'Ophaling manuele stortingen bevestigd',
        HoverCollectionNOK: 'Verschil ophaling',
        HoverCollectionNotesNOK: 'Verschil ophaling biljetten',
        HoverCollectionCoinsNOK: 'Verschil ophaling munten',
        HoverCollectionEnvelopeNOK: 'Veschil ophaling manuele stortingen',
        HoverDrain: 'Verwijderen',
        HoverRefill: 'Hervullen',
        HoverExchange: 'Wissel',
        HoverExchangeIn: 'Wissel in',
        HoverExchangeOut: 'Wissel out',
        HoverCounterfeit: 'Vals',
        HoverInternal: 'Interne transactie',
        HoverNOP: 'Geen operatie'
    },

    TransactionDayList: {
        Date: "Datum",
        Sales: "Verkoop",
        Pickup: "CIT",
        Balance: "Inventaris",
        TransactionDays: "Transactie dagen"
    },

    TransactionDay: {
        Date: "Datum",
        Sales: "Verkoop",
        Pickup: "CIT",
        Balance: "Inventaris",
        TransactionDays: "Transactie dagen",
        ExportTransactions: "Transacties"
    },

    TransactionDatePicker: {
        Date: 'Datum'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/nl.js